// Ctrl/Cmd+E = „Експорт в Excel" на справката, докато е отворена. Клавишът се
// чете по ФИЗИЧЕСКОТО място (`code === "KeyE"`) — с българска подредба
// `event.key` е „е" и сравнение по буквата не би хванало нищо. В модула няма
// друг Ctrl+E (листовете ползват Ctrl/Cmd+Enter, филтрите и изборът на период —
// стрелки/Enter/Esc), а браузърният (търсене в адресната лента) се спира с
// preventDefault. При отворен слой (модал на документ, попъп, падащо меню)
// клавишът е негов — нищо не правим. Без редове за експорт клавишът пак се
// поглъща, за да не скача фокусът в адресната лента.
import { useEffect, useRef } from "react";
import { hasOpenOverlay } from "../../../../lib/overlay";

export const isExcelShortcut = (event: Pick<KeyboardEvent, "code" | "ctrlKey" | "metaKey" | "altKey" | "shiftKey">) =>
  event.code === "KeyE" && (event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey;

type Options = {
  onExport: () => void;
  // има ли какво да се изнесе (иначе клавишът само се поглъща)
  canExport: boolean;
  // изключен, докато друг изглед е „отгоре" (складовата карта на цял екран)
  enabled: boolean;
};

export const useExcelShortcut = ({ onExport, canExport, enabled }: Options) => {
  // Последните стойности — без да се закача слушателят наново на всеки рендер
  const latest = useRef({ onExport, canExport });
  useEffect(() => {
    latest.current = { onExport, canExport };
  });

  useEffect(() => {
    if (!enabled) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (!isExcelShortcut(event) || event.defaultPrevented || hasOpenOverlay()) return;
      event.preventDefault();
      if (event.repeat || !latest.current.canExport) return;
      latest.current.onExport();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [enabled]);
};
